/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3HCircleIcon20Solid = forwardRef('UiMenuDots3HCircleIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm4-6.827a1.173 1.173 0 1 0 0-2.346 1.173 1.173 0 0 0 0 2.346ZM11.173 10a1.173 1.173 0 1 1-2.346 0 1.173 1.173 0 0 1 2.346 0ZM6 11.173a1.173 1.173 0 1 0 0-2.346 1.173 1.173 0 0 0 0 2.346Z" })));
});
